import {Component, ContentChildren, QueryList, AfterContentInit, DestroyRef} from '@angular/core';
import {TabComponent} from './tab/tab.component';
import {NgClass} from '@angular/common';
import {MetaData, NgEventBus} from 'ng-event-bus'; // Import TabComponent
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
    selector: 'nlr-tabset',
    templateUrl: './tabset.component.html',
    imports: [NgClass],
    styleUrls: ['./tabset.component.scss']
})
export class TabsetComponent implements AfterContentInit {
    @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;
    selectedTabIndex: number = 0; // Default selected tab index

    constructor(
        private eventBus: NgEventBus,
        private destroyRef: DestroyRef
    ) {}

    ngAfterContentInit() {
        this.tabs.forEach((tab, index) => {
            if (tab.active) {
                this.selectedTabIndex = index;
            }
        });
        this.makeSelectedTabActive();
        this.eventBus
            .on('nlr:selectTab')
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((meta: MetaData) => {
                // meta.data is an NLR_TABS id, which is also bound to each tab's id. Tabs are rendered
                // conditionally (*ngIf), so the id cannot be used as a positional index into the
                // QueryList - resolve the index by matching the tab id instead.
                const tabIndex = this.tabs.toArray().findIndex(tab => tab.id === meta.data);

                if (tabIndex >= 0) {
                    this.selectTab(tabIndex);
                }
            });
    }

    selectTab(index: number) {
        if (index !== this.selectedTabIndex) {
            const tab = this.tabs.get(index);
            if (tab && tab.preventSelection && tab.preventSelection()) {
                return;
            }
            this.selectedTabIndex = index;
            this.makeSelectedTabActive();
        }
    }

    private makeSelectedTabActive() {
        this.tabs.forEach((tab, i) => (tab.active = i === this.selectedTabIndex));
        const tab = this.tabs.get(this.selectedTabIndex);
        if (tab) {
            const tabId = tab.id;
            this.eventBus.cast('nlr:tabChange:' + tabId, tabId);
        }
    }
}
